var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plyr',{ref:"plyr",attrs:{"options":_vm.options}},[_c('div',{staticClass:"plyr__video-embed"},[_c('iframe',{attrs:{"src":_vm.src,"allowfullscreen":"","allowtransparency":"","allow":"autoplay"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }